import React from "react";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { isLoggedIn } from "../../../store/actions/authActions";
import configureAxios from "../../../store/utils/configureAxios";
import Login from "./login";

class AuthCheckingPageDtl extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			user: "",
			password: "",
			error: {},
		};
	}

	changeHandler = (event) => {
		this.setState({
			[event.target.name]: event.target.value,
		});
	};

	submitHandler = (event) => {
		event.preventDefault();

		this.props.logout(this.props.history);
	};

	async authCheck() {
		await configureAxios(); // Run Basic Axios Configure

		this.props.isLoggedIn(this.forceLogin);
	}
	forceLogin = () => {
		let { isAuthenticated, authChecking } = this.props.auth;
		if (!authChecking && !isAuthenticated) {
			// this.props.navigate("/login");
		}
	};
	componentDidMount() {
		this.authCheck();
	}

	render() {
		// let { user, password, error } = this.state
		// this.authCheck();

		const { isAuthenticated, authChecking } = this.props.auth;
		
		if (!authChecking && !isAuthenticated) {
			return <Login />; 
		}
		return (
			<div className="page-auth-checking">
				<div className="checking-content">
					<span className="loader"></span>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => ({
	auth: state.auth,
});
const mapDispatchToProps = {
	isLoggedIn: isLoggedIn,
};

function AuthCheckingPage(props) {
	let navigate = useNavigate();
	return <AuthCheckingPageDtl {...props} navigate={navigate} />
}

export default connect(mapStateToProps, mapDispatchToProps)(AuthCheckingPage);
